const workflowSteps = [
  { icon: "ri-search-2-line", title: "文献检索", desc: "智能推荐相关文献" },
  { icon: "ri-file-text-line", title: "综述写作", desc: "AI 辅助写作" },
  { icon: "ri-flask-line", title: "实验设计", desc: "数据分析工具" },
  { icon: "ri-award-line", title: "成果产出", desc: "成果可视化" },
];

export default function WorkflowSection() {
  return (
    <section id="workflow-section" className="py-24 bg-[#080808]">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-block text-xs text-[#3d69e8] font-medium tracking-widest uppercase mb-4">科研范式</div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">从想法到发现，AI 全程相伴</h2>
          <div className="w-12 h-0.5 bg-[#3d69e8] mx-auto mb-4"></div>
          <p className="text-sm text-white/40">用用户旅程可视化展示平台价值</p>
        </div>

        {/* Steps */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-0 mb-14">
          {workflowSteps.map((step, i) => (
            <div key={i} className="flex items-center">
              <div className="flex flex-col items-center text-center group">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-[#161616] border border-white/8 group-hover:border-[#3d69e8]/50 transition-colors mb-3">
                  <i className={`${step.icon} text-xl text-[#3d69e8]`}></i>
                </div>
                <div className="text-sm font-medium text-white">{step.title}</div>
                <div className="text-xs text-white/40 mt-1">{step.desc}</div>
              </div>
              {i < workflowSteps.length - 1 && (
                <div className="hidden md:flex items-center mx-6">
                  <i className="ri-arrow-right-line text-white/20 text-lg"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Quote */}
        <div className="max-w-2xl mx-auto bg-[#111111] border border-white/8 rounded-2xl px-8 py-8 text-center">
          <i className="ri-double-quotes-l text-3xl text-[#3d69e8]/40 mb-4 block"></i>
          <blockquote className="text-base md:text-lg text-white/70 leading-relaxed mb-5">
            "以前写综述需要阅读 200+ 篇文献，耗时 3 周。<br />
            现在 ScienceOne 帮我梳理知识图谱，2 天完成初稿。"
          </blockquote>
          <cite className="text-sm text-white/30 not-italic">— 某高校教授 · 物理学领域</cite>
        </div>
      </div>
    </section>
  );
}
